import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		bgImage: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',

			'&:after': {
				content: '""',
				transition: theme.transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				[theme.breakpoints.down('sm')]: {
					opacity: ({ mobileOpacity }) => (mobileOpacity?.toNumber() || 0) / 100,
				},
			},
		},

		content: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'stretch',
			maxWidth: theme.spacing(61),
			[theme.breakpoints.down('sm')]: {
				maxWidth: '100%',
			},
		},

		text: {
			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ mobileAlignment }) => mobileAlignment?.metaValue,
				},
			},
		},
		grid: {
			display: 'flex',
			justifyContent: 'flex-end',
		},
		image: {
			height: '100%',
			width: '100%',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'contain',
			display: 'flex',
		},

		mobileImage: {
			marginRight: theme.spacing(-2),
			marginLeft: theme.spacing(-2),

			'& picture': {
				display: 'flex',
				maxHeight: theme.spacing(40),
			},
			'& img': {
				objectFit: 'contain',
				objectPosition: 'center',
				width: '100%',
			},
		},

		imageWrapper: {
			width: '100%',

			[theme.breakpoints.down('sm')]: {
				width: 'auto',
				marginLeft: theme.spacing(-2),
				marginRight: theme.spacing(-2),
				transition: theme.transitions.create(['margin-top', 'margin-bottom']),

				marginTop: ({ mobileImagePosition }) => {
					if (!mobileImagePosition?.isRightAlignment) return null

					return theme.spacing(3)
				},
				marginBottom: ({ mobileImagePosition }) => {
					if (!mobileImagePosition?.isLeftAlignment) return null

					return theme.spacing(3)
				},
			},
		},

		buttonWrapper: {
			display: 'flex',

			[theme.breakpoints.down('xs')]: {
				justifyContent: ({ mobileAlignment }) => mobileAlignment?.contentAlignment() || 'center',
			},
		},

		buttonRoot: {
			width: 'auto',
			minWidth: theme.spacing(32.5),

			[theme.breakpoints.down('xs')]: {
				minWidth: 'auto',
				width: ({ mobileButtonWidth }) => (mobileButtonWidth?.isWide ? '100%' : 'auto'),
			},
		},
		textTop: {},
		textBottom: {},
	}),
	{ name: 'Banners-Banner2' },
)

export default useStyles
